/**
 * Australian state and territory codes, in the order a form should offer them.
 *
 * One copy: FleetVehiclesPage had the only list, and the fleet settings form needs the
 * same one. Two arrays drift the first time someone types 'NSW' before 'VIC' — and a
 * mismatch here is invisible, because both lists render fine.
 *
 * The values are what goes in the column: `vehicle.rego_state` and `customer.state` are
 * both VARCHAR(10), so the codes and not the full names.
 */
export const AU_STATES = ['VIC', 'NSW', 'QLD', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
